module.exports = __webpack_public_path__ + "aac582f72a6c425e08db98837d09e70a.svg";